import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { Observable } from 'rxjs';
import { Constant } from '../Shared/Constant';

@Injectable({
  providedIn: 'root'
})
export class hasRoleGuard implements CanActivate {

  
  constructor(
    protected readonly router: Router,
    protected readonly auth: AuthService
  ) {
    
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    var allowedPermissions: RoutePermissionRestriction[] = (route.data['permissions'] as RoutePermissionRestriction[]) ?? [];
    for (let i = 0; i < allowedPermissions.length; i++) {
      return this.auth.hasAnyPermission(allowedPermissions[i].permissions);
    }
    this.auth.forbidAccess();
    return false;
  }

}

export interface RoutePermissionRestriction {
  permissions: string[]
}
